/** @license DAFT Core v1.2.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/

import { ProcessorFunction } from './processor';
import { combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { JoinExpression, UuidExpression } from './expressions';
import { isNullOrUndefined } from '..';
import { DFSValueType } from './form';
import { v4 as uuidv4 } from 'uuid';

export const $join: ProcessorFunction<JoinExpression, string> = function(r, e, t) {
  var i = t.watch(r.glue, e);
  var n = t.watch(r.pieces, e);

  return combineLatest([i, n])
    .pipe(
      map((r: [DFSValueType, DFSValueType]) => {
        const [t, i] = r;

        if (!isString(t)) {
          console.warn(`$join (glue) requires a string. Got ${t}`);
          return null;
        }

        if (!isStringArray(i)) {
          console.warn(`$join (pieces) requires an array of strings. Got ${i}`);
          return null;
        }

        var n = i.filter(r => !isNullOrUndefined(r));

        if (n.length === 0) {
          return null;
        }

        return n.join(t);
      })
    )
};

export function isStringArray(r: DFSValueType): r is string[] {
  return Array.isArray(r) && r.some(isString);
}

export function isString(r: DFSValueType): r is string {
  return typeof r === 'string';
}

export const $uuid: ProcessorFunction<UuidExpression, string> = function(r, e, t) {
  return of(uuidv4());
}